import { useLayoutEffect, useState } from 'preact/hooks'

export const useMedia = (maxWidth: number) => {
  const query = `(max-width: ${maxWidth}px)`

  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(query).matches
      : false
  )

  useLayoutEffect(() => {
    const media = window.matchMedia(query)

    setMatches(media.matches)

    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    media.addEventListener('change', onChange)

    return () => {
      media.removeEventListener('change', onChange)
    }
  }, [query])

  return matches
}

export const useIsMobile = () => {
  return useMedia(1023)
}
